import { T } from "@supersig/validate";
import { opacityValidator } from "../misc/SWOpacity";
import { idValidator } from "../misc/id-validator";
/** @public */ export const shapeParentIdValidator = T.string.refine((id)=>{
    if (!id.startsWith("page:") && !id.startsWith("shape:")) {
        throw new Error('Parent ID must start with "page:" or "shape:"');
    }
    return id;
});
/** @public */ export const shapeIdValidator = idValidator("shape");
/** @public */ export function createShapeValidator(type, props, meta) {
    return T.object({
        id: shapeIdValidator,
        typeName: T.literal("shape"),
        x: T.number,
        y: T.number,
        rotation: T.number,
        index: T.string,
        parentId: shapeParentIdValidator,
        type: T.literal(type),
        isLocked: T.boolean,
        opacity: opacityValidator,
        props: props ? T.object(props) : T.jsonValue,
        meta: meta ? T.object(meta) : T.jsonValue
    });
}
